import MypageCouponContainer from './MypageCouponContainer';
export default MypageCouponContainer;
